import * as z from 'zod'
import { GetApiContract, PostApiContract } from './ApiContract.js'
import { DIsinEntity, IsinEntity, IsinStatType } from '../IsinEntity.js'

export const postIsinSchema = z.object({
    isin: z.string(),
    archived: z.enum(['true']),
})

export interface PostIsinRequest extends PostApiContract {
    Body: z.infer<typeof postIsinSchema>
    Response: {
        archived: true
        isin: string
    }
    ResponseJson: {
        archived: true
        isin: string
    }
}

export const getIsinListQueryParamSchema = z.object({
    unused: z.enum(['true']),
})

export interface GetIsinListRequest extends GetApiContract {
    QueryParameters: z.infer<typeof getIsinListQueryParamSchema>
    Response: Array<DIsinEntity>
    ResponseJson: Array<IsinEntity>
}

export interface GetIsinSingleItemRequest extends GetApiContract {
    Response: { isins: Record<IsinStatType, number> | { total: number } }
    ResponseJson: { isins: Record<IsinStatType, number> | { total: number } }
}
